ui-usercentrics-overlay {
  position: relative;
  display: block;

  div[class^='uc-blocker--'] {
    display: none;
  }

  .uc-embedding-container {
    position: absolute;
    width: 100%;
    height: 100%;
    max-height: unset;
    background-color: rgb(
      0.2 0.2 0.2 / 70%
    ); // This background follows the background overlay of usercentrics

    top: 0;
    left: 0;
  }
}
